import ax from '../api'
/*
* setSprint - Set a sprint item on the server
* @param {string} workflowId - The id of the sprint item
* @param {object} full - The full object of the sprint item
* @returns {object} The response from the server

*/
export const setWorkflow = async (workflowId, full) => {
	// Convert full object to JSON string
	const fullStr = JSON.stringify(full)

	// Send POST request with data in the body
	try {
		const response = await ax.post(`/features/workflows/set.php`, {
			workflow_id: workflowId,
			full: fullStr
		})
		return response
	} catch (error) {
		console.error('Error in setSprint:', error)
		throw error
	}
}
